module.exports = __webpack_public_path__ + "img/8ebaf0c.png";